// ##### 23-12-27 Komarov
import axios from 'axios';
// ##### Komarov 2025-07-12
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// ##### 23-04-12 Komarov
import uniqueId from 'lodash.uniqueid';
// ##### 25-01-14 Komarov
import { getPostObject } from '../../../helpers/crypto';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../server/helpers/uniLog';

// ##### 23-09-14 Komarov
// import './CanxBookingCSS.css'

// ##### Komarov 2025-07-14
const CanxBookingButton = ({ email, bookingNumber }) => {
  const [CancelServicesRQ, setCancelServicesRQ] = useState();
  const { user: currentUser } = useSelector(state => state.auth);

  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);

  // ##### 24-03-01 Komarov
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    const data = {
      // ##### 25-02-12 Komarov
      company_cipher: company_cipher || '',
      site_buyer_id: 1, // index of the buyer in the site (by default = 1), it is not in Smart's DB
      buyer_email: email, // For registered user this email can be omitted
      // but this parameter "buyer_email" is mandatory for unregistered user
      // Multiple bookings can be canceled
      services: [
        {
          site_order_id: 1, // index of the order in the site (by default = 1), it is not in Smart's DB
          smart_order_reference: bookingNumber, // booking.reference - customer reference
          site_service_id: 1, // index of the service in the site, it is not in Smart's DB
          smart_service_number: 1, // booking_entity.ref_serv_smart - by default = 1
        },
      ],
    };

    const postObject = getPostObject({
      action: 'GetBookingsRQ',
      user_id: currentUser.user_id,
      refpartner: currentUser.company_id, // If "= 1361" - it is Id of "hotelsukraine
      language: locale,
      data,
    });

    axios
      .post(postObject.url, postObject.parameters)
      // ##### 24-11-01 Komarov
      .then(async response => {
        setCancelServicesRQ(await response.data);
      });
    // ##### 23-04-12 Komarov
  }, [
    currentUser.user_id,
    locale,
    email,
    bookingNumber,
    // ##### 24-03-21 Komarov
    company_cipher,
  ]);

  // ##### 25-04-30 Komarov
  uniLog('CancelServicesRQ', CancelServicesRQ);

  // ##### Komarov 2025-08-05
  const yourBookingIsCancelled =
    useSelector(state => state.pagesRedux[state.language]?.YourBookingIsCancelled || '');
  const requestNotProcessed =
    useSelector(state => state.pagesRedux[state.language]?.RequestNotProcessed || '');

  return (
    <div data-component="CanxBookingButton">
      {
        // ##### 24-03-21 Komarov
        CancelServicesRQ?.map(item => {
          if (item.success === true) {
            return (
              // ##### 23-04-12 Komarov
              <div key={uniqueId()}>
                {/* ##### 23-09-07 Komarov */}
                {yourBookingIsCancelled}
              </div>
            );
          }

          // ##### 24-09-09 Komarov
          return (
            <div key={uniqueId()}>
              {/* ##### 23-09-07 Komarov */}
              {requestNotProcessed}
            </div>
          );
        })
      }
    </div>
  );
};

export default CanxBookingButton;
